import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

// ─────────────────────────────────────────────
//  GESTION DES COMPTES ADMIN SYSTÈME
//  Routes : /api/system/admins/*
//
//  Différence avec les users clients :
//   - Pas de company (company = null)
//   - Les permissions sont des ADMIN_* (pas des permissions client)
//   - Gérés depuis la page Paramètres système, pas depuis UsersPage
// ─────────────────────────────────────────────

/** Liste tous les comptes admin système (sous-admins + SUPER_ADMIN). */
export const getAdmins = async () => {
  try {
    const res = await api.get("/users/system/admins");
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Crée un sous-admin avec des permissions ADMIN_* spécifiques.
 * payload : {
 *   firstName, lastName, email, password,
 *   permissionOverrideNames: ["ADMIN_USER_MANAGE", "ADMIN_COMPANY_MANAGE", ...]
 * }
 */
export const createAdmin = async (payload) => {
  try {
    const res = await api.post("/users/system/admins/create", payload);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Modifie un sous-admin (nom, email, permissions).
 * Les permissions remplacent entièrement les précédentes.
 */
export const updateAdmin = async (id, payload) => {
  try {
    const res = await api.put(`/users/system/admins/${id}`, payload);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Active ou désactive un compte sous-admin.
 * @param {string}  id
 * @param {boolean} active
 */
export const toggleAdminActive = async (id, active) => {
  try {
    const res = await api.put(`/users/system/admins/${id}/toggle-active`, { active });
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/** Supprime un sous-admin. Impossible de se supprimer soi-même. */
export const deleteAdmin = async (id) => {
  try {
    const res = await api.delete(`/users/system/admins/${id}`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

// ─────────────────────────────────────────────
//  PERMISSIONS ADMIN_* DISPONIBLES
//  Affichées dans le formulaire de création/édition d'un sous-admin.
// ─────────────────────────────────────────────

/**
 * Liste des permissions ADMIN_* avec leurs descriptions lisibles.
 * Ces données sont statiques — elles correspondent à PermissionName.java.
 * On ne les charge pas depuis l'API car /roles/permissions filtre les ADMIN_*.
 */
export const ADMIN_PERMISSIONS = [
  {
    name:        "ADMIN_CREDENTIAL_MANAGE",
    description: "Gérer les mots de passe d'entreprise (toutes entreprises)",
    icon:        "bi-shield-lock",
  },
  {
    name:        "ADMIN_FOLDER_MANAGE",
    description: "Gérer les dossiers de mots de passe",
    icon:        "bi-folder",
  },
  {
    name:        "ADMIN_POLICY_MANAGE",
    description: "Configurer la politique de mot de passe",
    icon:        "bi-shield-check",
  },
  {
    name:        "ADMIN_USER_MANAGE",
    description: "Gérer les utilisateurs des entreprises et les sous-admins",
    icon:        "bi-people",
  },
  {
    name:        "ADMIN_ROLE_MANAGE",
    description: "Gérer les rôles et leurs permissions",
    icon:        "bi-person-badge",
  },
  {
    name:        "ADMIN_COMPANY_MANAGE",
    description: "Créer et modifier les entreprises clientes",
    icon:        "bi-building",
  },
];